import React from "react";

function AzaleaLogo() {
  return (
    <svg
      width="118"
      height="80"
      viewBox="0 0 118 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M79.2128 41.3071L71.5427 46.1305L56.0422 32.382L71.8832 39.7182L58.2029 19.7093L39.2173 45.545L58.2925 7.85742L79.2128 41.3071Z"
        fill="#F5C30B"
      />
      <path
        d="M27.2286 54.4727L41.54 54.4803V56.4864C39.0467 59.7602 35.5044 64.5352 33.0723 67.8545H41.54V71.3524H26.8765V69.6549L35.5597 58.1167H27.2139L27.2288 54.4727H27.2286Z"
        fill="#4072C8"
      />
      <path
        d="M47.56 71.3524L51.904 61.372L56.299 71.3524H60.6852L52.8376 54.4727L50.8596 54.4738L43.0195 71.3524H47.56Z"
        fill="#4072C8"
      />
      <path
        d="M12.272 71.3524L16.6159 61.372L21.0109 71.3524H25.3971L17.5495 54.4727L15.5715 54.4738L7.73145 71.3524H12.272Z"
        fill="#4072C8"
      />
      <path
        d="M63.3723 70.775V55.0742H62.0225V70.775V71.9463H63.3723H73.1088V70.775H63.3723Z"
        fill="#4072C8"
      />
      <path
        d="M79.9358 70.1813V63.8067H88.4878V62.6353H79.9358V55.6518H90.0233V54.4805H79.9358H78.5859V55.6518V62.6353V63.8067V70.1813V71.3526H79.9358H90.4662V70.1813H79.9358Z"
        fill="#4072C8"
      />
      <path
        d="M108.98 71.397L110.269 71.3947L102.603 54.5156H101.733L94.0664 71.3947L95.3556 71.397L97.4074 66.8797H106.928L108.98 71.397H108.98ZM97.9397 65.7086L102.168 56.3996L106.396 65.7086H97.9397Z"
        fill="#4072C8"
      />
    </svg>
  );
}

export default AzaleaLogo;
